import type {BioIconProps} from './common-types'

export function VerifiedReviewsIcon({...attributes}: BioIconProps) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M9.66663 13.25L11.9166 15.5L15.6666 10.25M21.6666 12.5C21.6666 13.7683 21.037 14.8895 20.0733 15.5682C20.2747 16.7294 19.9271 17.9672 19.0304 18.8639C18.1337 19.7606 16.8958 20.1083 15.7346 19.9069C15.056 20.8705 13.9348 21.5 12.6666 21.5C11.3985 21.5 10.2774 20.8705 9.59867 19.907C8.43728 20.1086 7.19918 19.761 6.30233 18.8641C5.40549 17.9673 5.05787 16.7292 5.25949 15.5678C4.29603 14.8891 3.66663 13.7681 3.66663 12.5C3.66663 11.2319 4.29609 10.1108 5.2596 9.43208C5.0581 8.27079 5.40573 7.03284 6.3025 6.13607C7.19928 5.23929 8.43726 4.89166 9.59856 5.09319C10.2772 4.12955 11.3984 3.5 12.6666 3.5C13.9348 3.5 15.0559 4.1295 15.7346 5.09307C16.896 4.89145 18.1341 5.23906 19.0309 6.1359C19.9278 7.03274 20.2754 8.27081 20.0738 9.43218C21.0372 10.1109 21.6666 11.2319 21.6666 12.5Z"
        stroke="#030303"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
